// @flow
import * as React from 'react';
import logo from 'images/logo.png';

const Logo = ({ className = '' }) => <img className={className} src={logo} alt="AlamoCattle" />;

export default Logo;
